<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-2">
                    <a 
                        class="navbar-brand ml-3"
                        style="font: normal normal normal 16px/25px Poppins;">Cek Status TO</a>
                </div>
                <div class="col-md-8" style="">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor TO"
                        aria-label="Search"
                        style="display: flex; font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-2 text-right" style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <!-- Title & Option Buttons Start -->

            <div class="mb-4 row">
                <div class="col-md-3">
                    <!-- <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button> -->
                </div>
                <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">List Status TO</h3>
                </div>
                <div class="col-md-5">
                    <div class="d-flex align-items-center justify-content-end" style="gap: 15px;">
                        <div style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
                            <span style="font: normal normal normal 12px/18px Poppins;">Filter Tanggal</span>
                        </div>
                        <div style="width: 200px; flex-shrink: 0; font: normal normal normal 12px/18px Poppins;">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                                style="font: normal normal normal 12px/18px Poppins; width: 100% !important;"
                            ></flat-pickr>
                        </div>
                        <button
                            v-if="isAccountingUser"
                            class="btn"
                            type="button"
                            style="
                                background-color: #c9ecfb;
                                color: #333333;
                                font-weight: normal;
                                padding: 8px 24px;
                                white-space: nowrap;
                                font: normal normal normal 14px/21px Poppins;
                            "
                            @click="downloadExcel"
                            :disabled="isDownloading"
                        >
                            {{ isDownloading ? 'Downloading...' : 'Download' }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Title & Option Buttons End -->
            <vue-universal-table
                api_url="/api/monitoring/status-to"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :process_data="vue_universal_table.process_data"
                :infinite_scroll="true"

                sort_order="ASC"
                sort_by="tanggal_dokumen"
                style="font: normal normal normal 12px/18px Poppins;"
            ></vue-universal-table>
        </div>
        <!-- Table End -->
    </div>
</template>

<script>
    import moment from 'moment'
    import debounce from 'debounce';
    import qs from 'qs';

    export default {
        metaInfo : {
            title : 'Monitoring Status TO'
        },
        data () {
            let startDate = moment().startOf('year').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                isDownloading: false,
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input elegant-flatpickr'
                },
                selected : {
                    dateButtonsIndex : 2,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    search : '',
                    start: startDate,
                    end: currentDate
                },
                vue_universal_table : {
                    fields : [
                        {title:"NOPOL", variable:"nopol"},
                        {title:"SJ Total", variable:"sj_total"},
                        {title:"SJ Terkirim", variable:"jumlah_terkirim"},
                        {title:"Ekspedisi", variable:"ekspedisi"},
                        {title:"TGL TO", variable:"tanggal_dokumen"},
                        {title:"NO TO", variable:"no_referensi"},
                        // {title:"RUTE", variable:"jumlah_titik"},
                        {title:"JUMLAH TITIK", variable:"jumlah_titik"},
                        {title:"TITIK TERJAUH", variable:"titik_terjauh"},
                    ],
                    update : 0,
                },
            }
        },
        computed: {
            isAccountingUser() {
                const user = this.$store.getters.currentUser;
                return user && user.role === 'ACCOUNTING';
            },
        },
        mounted () {

        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
                
                this.updateDebounceData();
            },
        },
        methods : {
            updateDebounceData: debounce(function () {
                this.vue_universal_table.update++
            }, 1500),
            downloadExcel() {
                if (this.filter.search === '') delete this.filter.search;

                this.isDownloading = true;
                this.$http.get(`/api/monitoring/status-to/export-excel?${qs.stringify(this.filter, { skipNulls: true, arrayFormat: 'comma' })}`, { responseType: 'blob' })
                    .then((response) => {
                        const href = URL.createObjectURL(response.data);
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', `status-to-${moment().format('YYYYMMDDHHmmss')}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        this.isDownloading = false;
                    });
            },
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>
